import { render, staticRenderFns } from "./subsidy-task.vue?vue&type=template&id=832ff5b6&scoped=true&lang=pug&"
import script from "./subsidy-task.vue?vue&type=script&lang=js&"
export * from "./subsidy-task.vue?vue&type=script&lang=js&"
import style0 from "./subsidy-task.vue?vue&type=style&index=0&id=832ff5b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832ff5b6",
  null
  
)

export default component.exports